import { unifyUrlFormat } from '@luna/router';

import type { Tracker } from '../model/Tracker';
import { TrackingEvent } from '../model/TrackingEvent';
import type { ScriptErrorDetail } from './ScriptErrorDetail';

export class ScriptErrorTrackService {
    tracker: Tracker;

    constructor(tracker: Tracker) {
        this.tracker = tracker;
    }

    track(type: string, name: string, errorDetail: ScriptErrorDetail): void {
        this.tracker.track(this.createTrackingEvent(type, name, errorDetail));
    }

    createTrackingEvent(
        type: string,
        name: string,
        scriptErrorDetail: ScriptErrorDetail,
    ): TrackingEvent<any> {
        return new TrackingEvent(
            type,
            name,
            unifyUrlFormat(window.location.hash),
            scriptErrorDetail,
        );
    }
}
